import React, { useEffect, useState } from 'react';
import Header from "components/Header/Header.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import {colors} from '../components/Theme/WebTheme';
import Hero from "../components/Hero";
import Section from "../components/Section";
import Download from "../components/Download";
import { Helmet } from 'react-helmet-async';

import { useSelector } from "react-redux";

const dashboardRoutes = [];

export default function LandingPage(props) {

  const auth = useSelector(state => state.auth);

  const { ...rest } = props;

  const [role, setRole] = useState();

  useEffect(() => {
    if (auth && auth.profile) {
      if(auth.profile.uid){
        let role = auth.profile.usertype;
        setRole(role);
      }
    }
  }, [auth]);

  return (
    <div style={{backgroundColor:colors.LandingPage_Background,margin:'-8px'}}>
        <Helmet>
        <title>Hızlı ve Güvenilir Kurye Hizmeti</title>
        <meta name="description" content="7/24 güvenilir kurye hizmeti. Şehir içi ve şehirler arası express teslimat, motorlu kurye ve araçlı kurye hizmetleri. Hemen sipariş verin!" />
        <meta name="keywords" content="kurye, motorlu kurye, araçlı kurye, express kurye, hızlı teslimat, şehir içi kurye, şehirler arası kurye" />
        <meta property="og:title" content="Web Delivery - Profesyonel Kurye Hizmetleri" />
        <meta property="og:description" content="Güvenilir ve hızlı kurye hizmeti. 7/24 teslimat garantisi ile tüm gönderileriniz güvende." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://webdelivery.com" />
      </Helmet>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Hero role={role}/>
      <Section role={role} color={colors}/>
      <Download />
      <HomeFooter />
    </div>
  );
}
